var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8384 12.3003C14.8492 11.4657 15.0715 10.6473 15.4847 9.92134C15.8978 9.19538 16.4885 8.58544 17.2015 8.14827C16.7485 7.50311 16.1509 6.97217 15.4561 6.59762C14.7614 6.22306 13.9886 6.01522 13.1992 5.99059C11.5152 5.81433 9.8827 6.99542 9.02459 6.99542C8.14987 6.99542 6.82867 6.00809 5.40596 6.03728C4.48571 6.06693 3.58885 6.33378 2.80277 6.81184C2.0167 7.2899 1.3682 7.96286 0.920483 8.76515C-1.01895 12.1136 0.427692 17.0346 2.2855 19.7412C3.21501 21.0666 4.30133 22.547 5.72276 22.4945C7.11371 22.437 7.63321 21.61 9.31221 21.61C10.9756 21.61 11.463 22.4945 12.9133 22.4611C14.4058 22.437 15.3462 21.1299 16.2431 19.792C16.911 18.8476 17.4249 17.8039 17.7658 16.6995C16.8987 16.3338 16.1587 15.7216 15.6381 14.9393C15.1175 14.157 14.8394 13.2392 14.8384 12.3003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0992 4.20937C12.913 3.23516 13.3139 1.98298 13.2168 0.71875C11.9735 0.84897 10.825 1.44153 10.0002 2.37836C9.59697 2.83603 9.28811 3.36846 9.09131 3.94523C8.89452 4.522 8.81364 5.13179 8.85332 5.73975C9.4752 5.74614 10.0904 5.61172 10.6527 5.34663C11.2149 5.08155 11.7095 4.6927 12.0992 4.20937Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStoreIcon);
export default __webpack_public_path__ + "static/media/appleStoreIcon.4e6860bb7fe7d1fefb12e594b5a4c9fd.svg";
export { ForwardRef as ReactComponent };